import React from 'react';

import {
  useMITFiltersForm,
  MITFiltersFormValues,
  mitFiltersEmptyValues,
} from '../../../../hooks/useMITFiltersForm';
import { BaseFiltersPanel } from '../../../Paylinks/components/BaseFiltersPanel';
import { MITFilters } from './MITFilters';
import { useMerchant } from '../../../../contexts/MerchantContext';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  filters: MITFiltersFormValues;
  onApplyFilters: (filters: MITFiltersFormValues) => void;
}

export const MITFiltersPanel = ({ isOpen, onClose, filters, onApplyFilters }: Props) => {
  const { merchantId } = useMerchant();

  const formProps = useMITFiltersForm({
    initialValues: filters,
  });

  const { handleSubmit, formState, reset, control, watch, setValue } = formProps;

  const handleApply = handleSubmit((data) => {
    onApplyFilters(data);
    onClose();
  });

  const handleClear = () => {
    reset(mitFiltersEmptyValues);
  };

  const handleCancel = () => {
    onClose();
  };

  const currentFilters = watch();
  const filtersCount = Object.entries(currentFilters).filter(([key, value]) => {
    if (key === 'status') return (value as string[]).length > 0;
    if (key === 'customers') return (value as any[]).length > 0;
    if (key === 'createdAfter' || key === 'createdBefore') return value !== null;
    if (key === 'amountGTE' || key === 'amountLTE') return value !== '';
    return false;
  }).length;

  return (
    <BaseFiltersPanel
      isOpen={isOpen}
      onCancel={handleCancel}
      onReset={handleClear}
      onSubmit={handleApply}
      filtersCount={filtersCount}
    >
      <MITFilters
        merchantId={merchantId}
        hookFormProps={{
          watch,
          setValue,
          control,
          errors: formState.errors,
        }}
      />
    </BaseFiltersPanel>
  );
};
